import createAxiosConfig from "../config/createAxiosConfig";
import store from "../config/store";

class TefHubApi {
  constructor(url) {
    this.url = url;
    this.axiosConfig = createAxiosConfig(store.terminalTefUrl);
  }

  async post(body) {
    return this.axiosConfig
      .post(this.url, body)
      .then(function (reponse) {
        return reponse;
      })
      .catch(function (erro) {
        return erro;
      });
  }

  async get() {
    let urlGet = this.url;
    return this.axiosConfig
      .get(urlGet)
      .then(function (response) {
        return response;
      })
      .catch(function (erro) {
        return erro;
      });
  }

  async put(body) {
    return this.axiosConfig
      .put(this.url, body)
      .then(function (response) {
        return response;
      })
      .catch(function (erro) {
        return erro;
      });
  }
}


export default TefHubApi;
